import { useRef } from 'react'
import className from 'classnames'

export type SwitchProps = {
  small?: boolean
  disabled?: boolean
  checked?: boolean
  defaultChecked?: boolean
  name?: string
  value?: string
  onChange?: (c: boolean) => void
  onClick?: () => void
}

export const Switch = ({
  small,
  onChange,
  disabled,
  ...props
}: SwitchProps) => {
  const inputRef = useRef(null)

  return (
    <div
      className={className('Switch', {
        'Switch--small': small,
        'Switch--disabled': disabled,
      })}
      onClick={() => {
        inputRef.current.click()
      }}
      role="button"
    >
      <div className="Switch__wrapper-outer">
        <input
          ref={inputRef}
          type="checkbox"
          onChange={(e) => onChange?.(e.target.checked)}
          {...props}
        />
        <div className="Switch__wrapper" />
      </div>
    </div>
  )
}
